import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

// import addCookieWithConsent from '../../utilities/addCookieWithConsent';
import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  // tryToGetMemberships  
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Edit organization profile
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestEditOrganizationProfile = packet => {
  return {
    type: 'REQUEST_EDIT_ORGANIZATION_PROFILE',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveEditOrganizationProfileSuccess = data => ({
  type: 'RECEIVE_EDIT_ORGANIZATION_PROFILE_SUCCESS',
  data
})

export const receiveEditOrganizationProfileFail = data => ({
  type: 'RECEIVE_EDIT_ORGANIZATION_PROFILE_FAIL',
  data
})

export const tryToEditOrganizationProfile = packet => (dispatch, getState) => {

  dispatch(requestEditOrganizationProfile(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/organizations/profile/' + packet.id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveEditOrganizationProfileSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveEditOrganizationProfileFail({errors:e, lastSubmit: packet}));
    })
}
